/**
 * Created by Mark on 24/04/2017.
 */


import Class from '../classes/class.js'

export default class Student{
    constructor(uid , name , username , password , classes , lastLogin) {
        this.uid = uid;
        this.name = name;
        this.username = username;
        this.password = password
        this.profileLink = this.getLink();
        this.assignedHomework = 0
        this.completedHomework = 0;
        this.totalStudentsLink = this.getStudentsLink()
        this.rank = 0;
        this.wordsLearnt = 0;
        this.learnt = 0;
        this.classesRaw = (classes || [])
        this.classes = (classes || []).map(function(_class){
            return new Class(_class.uid , _class.name , _class.students || []);
        })

        this.classesLinks = (classes || []).map(function(_class){
            return new Class(_class.uid , _class.name , _class.students || []).getLink();
        })

        this.lastLogin = lastLogin ? this.format(lastLogin) : " - ";


    }

    format(dateStr) {


        //var dateStr="2011-08-03 09:15:11"; //returned from mysql timestamp/datetime field
        var a=dateStr.split(" ");
        var d=a[0].split("-");
        var t=a[1].split(":");
        var myDate = new Date(d[0],(d[1]-1),d[2],t[0],t[1],t[2]);

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        return pad(myDate.getDate() ,  2) + "-" + pad((myDate.getMonth() + 1) , 2 ) + "-" + myDate.getFullYear().toString().substr(-2);;
    }

    get(key){
        return this[key] || 'undefined';
    }

    getName() {
        return this.name;
    }

    getLink(){
        return {link:'student/profile/'+this.uid ,  value:this.name};
    }

    getStudentsLink(){
        return {link:'class/profile/'+this.uid+'/students' ,  value:3};
    }

    getID(){
        return this.uid;
    }

    getName(){
        return this.name;
    }
}


// WEBPACK FOOTER //
// ./src/classes/student.js